import React from 'react';
import Iconify from 'src/components/iconify';
import { Box, Button, Card, Divider, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import RenderField from '../../risk-register/render-field';
const RiskTrendAnalaysisTable = ({ data }) => {
    console.log("🚀 ~ teamtable ~ data:", data)
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    };
    return (
        <Card>
            <Box p={3}>
                <Typography className=" Escalation-view-main-heading">Risk Trends and Analysis Report View</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
                <Box sx={{ position: 'relative' }}>
                    <Typography variant="h4" className="pull-left mt-2 ribbon ribbon-bookmark ribbon-success">
                       Risk Trends and Analysis Report View{' '}
                    </Typography>
                </Box>
                <Box>
                    <Button
                        className='dark-button'
                        sx={{ marginRight: '20px', marginTop: '22px' }}
                        onClick={goBack}
                        size="md"
                        variant="contained"
                        startIcon={<Iconify icon="ep:back" width={16} />}
                    >
                        Go Back
                    </Button>
                </Box>
            </Box>
            <Box
                p={4}
                mt={4}
                rowGap={3}
                columnGap={20}
                display="grid"
                gridTemplateColumns={{
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(3, 1fr)',
                }}
            >
                <RenderField label="Report ID" value={data?.report_id} />
                <RenderField label=" Reporting Period" value={data?.reporting_period} />
                <RenderField label=" Key Risk Trends Identified" value={data?.key_risk_trend_identified} />
            
            </Box>
            <Divider />
            <Box
                p={4}
                rowGap={3}
                columnGap={20}
                display="grid"
                gridTemplateColumns={{
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(3, 1fr)',
                }}
            >
                <RenderField label="Recommendations" value={data?.recommendations} />
                <RenderField label="File" value={data?.file?.name} />
            </Box>
            <Divider />
        </Card>
    );
};
export default RiskTrendAnalaysisTable;